import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'
import { Img2d10 } from '@gympass/yoga-illustrations'

import Appbar from '@components/Appbar'
import Footer from '@components/Footer'
import Container from '@components/Container'

import useInternationalization from '@hooks/useInternationalization'
import useContact from '@hooks/useContact'
import useFunnelStage from '@hooks/useFunnelStage'
import calculatePrice from '@client/services/proposal'

import YelpPixel from '@components/YelpPixel'

import * as Style from './Interest.style'

export default function Interest() {
  const { contact } = useContact()
  const { country, countryFullName } = useInternationalization()
  const { setFunnelStage } = useFunnelStage(countryFullName)

  useEffect(() => {
    async function getOffer() {
      const { data } = await calculatePrice(contact.employeesNumber, country)

      const offer = {
        proposalValueWithoutDiscount: data.value,
        id: contact.id,
        funnelStage: 'meeting_intent',
        commercialOfferLink: `${window.location.protocol}//${window.location.host}/digital/${country}/simulate/commercial-offer?magic-link=${contact.magicLink}`,
      }

      await setFunnelStage(offer)
    }
    getOffer()
  }, [])

  function backToHome() {
    window.open('https://gympass.com/digital')
  }

  return (
    <div>
      <Appbar />

      <Container>
        <Style.Main>
          <Row>
            <Col md={7} xxs={12} xl-start={1} xl={8}>
              <Style.Title>
                <FormattedMessage id="smb_acquisition_thankyou.medium_companies.title" />
              </Style.Title>

              <Style.Subtitle>
                <FormattedMessage id="smb_acquisition_thankyou.medium_companies.subtitle" />
              </Style.Subtitle>

              <Style.Subtitle>
                <FormattedMessage
                  id="smb_acquisition_thankyou.medium_companies.links_section"
                  values={{
                    a: (...chunks) => (
                      <a
                        href={
                          country === 'us'
                            ? 'https://blog.gympass.com/en/?utm_source=website&utm_campaign=USA-website-handsup-thankyou-page&utm_medium=handsup-thankyou-page'
                            : 'https://blog.gympass.com/?utm_source=website&utm_campaign=LATAM-BRA-website-handsup-thankyou-page&utm_medium=handsup-thankyou-page'
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        {chunks}
                      </a>
                    ),
                  }}
                />
              </Style.Subtitle>

              <Style.ButtonWrapper>
                <Style.Button onClick={backToHome}>
                  <Style.ButtonText>
                    <FormattedMessage id="smb_acquisition_thankyou.above_threshold.call_to_action.default" />
                  </Style.ButtonText>
                </Style.Button>
              </Style.ButtonWrapper>
            </Col>

            <Col md={5} xl={2} hide={['xxs', 'xs', 'sm']}>
              <Img2d10
                width={230}
                height={230}
                role="figure"
                aria-label="i2s-settings-modal"
              />
            </Col>
          </Row>
        </Style.Main>
      </Container>

      <Footer />
      <YelpPixel
        revenue={contact.proposalValue}
        orderid={contact.id}
        country={country}
      />
    </div>
  )
}
